import { memo, useState, useEffect } from 'react';
import { Input } from '@shared/ui/kit';
import { useDebouncedValue } from '@shared/hooks/useDebouncedValue';
import { SearchIcon, CrossIcon } from '@shared/assets/icons';
import { UnstyledButton } from '@shared/ui/unstyled-button';
import * as stylex from '@stylexjs/stylex';
import { styles } from '../styles';

const SEARCH_DEBOUNCE_MS = 300;

interface CategorySearchInputProps {
  onSearchChange: (value: string) => void;
}

export const CategorySearchInput = memo<CategorySearchInputProps>(({ onSearchChange }) => {
  const [value, setValue] = useState('');
  const debouncedValue = useDebouncedValue(value, SEARCH_DEBOUNCE_MS);

  useEffect(() => {
    onSearchChange(debouncedValue);
  }, [debouncedValue, onSearchChange]);

  const handleClear = () => {
    setValue('');
  };

  return (
    <div {...stylex.props(styles.searchInputWrapper)}>
      <Input
        status="default"
        placeholder="Поиск"
        value={value}
        size="small"
        settings={{ width: '100%' }}
        changeFunction={setValue}
      />
      <UnstyledButton onClick={handleClear}>
        {value ? (
          <i {...stylex.props(styles.crossIcon)}>
            <CrossIcon />
          </i>
        ) : (
          <i {...stylex.props(styles.searchIcon)}>
            <SearchIcon />
          </i>
        )}
      </UnstyledButton>
    </div>
  );
});
